export const GET_LANGUAGES_START = "@languages/GET_LANGUAGES_START";
export const GET_LANGUAGES_SUCCESS = "@languages/GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_FAIL = "@languages/GET_LANGUAGES_FAIL";
export const RESET_STORE = "@languages/RESET_STORE";
